'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Create = _interopRequireDefault(require("@material-ui/icons/Create"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _EditCompanyActivityModal = _interopRequireDefault(require("Modals/EditCompanyActivityModal"));
var _DeleteCompanyActivityModal = _interopRequireDefault(require("Modals/DeleteCompanyActivityModal"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class CompanyActivityForm extends _react.Component {
  state = {
    loading: false,
    status_messages: {},
    editedCompanyActivityId: undefined,
    deletingCompanyActivityId: undefined,
    editCompanyActivityModalOpen: false,
    deleteCompanyActivityModalOpen: false
  };
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCompanyActivity();
  }
  fetchCompanyActivity = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    component.setState({
      loading: true
    });
    qwest.post('/company-activity/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        company_activities: response.company_activities
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const company_activity = (0, _getFormData.default)({
      state: state,
      pattern: 'company_activity['
    });
    qwest.post('/company-activity/create', company_activity).then(function (xhr, response) {
      component.clearForm();
      window.setTimeout(function () {
        component.fetchCompanyActivity();
      }, 1500);
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('company_activity[')).reduce(function (update, key) {
      if (_is_js.default.string(state[key])) {
        update[key] = '';
      } else if (_is_js.default.array(state[key])) {
        update[key] = [];
      } else if (_is_js.default.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  openEditCompanyActivityModal = ({
    id
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      editedCompanyActivityId: id,
      editCompanyActivityModalOpen: true
    });
  };
  closeEditCompanyActivityModal = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      editedCompanyActivityId: undefined,
      editCompanyActivityModalOpen: false,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    component.fetchCompanyActivity();
  };
  openDeleteCompanyActivityModal = ({
    id
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      deletingCompanyActivityId: id,
      deleteCompanyActivityModalOpen: true
    });
  };
  closeDeleteCompanyActivityModal = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      deletingCompanyActivityId: undefined,
      deleteCompanyActivityModalOpen: false,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    component.fetchCompanyActivity();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let listCompanyActivity = (state.company_activities || []).sort(function (a, b) {
      let labelA = a.label.toLowerCase(),
        labelB = b.label.toLowerCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    }).map(currentCompanyActivity => {
      return /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 3,
        classes: props.classes,
        key: currentCompanyActivity.label
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 4,
        classes: props.classes
      }, currentCompanyActivity.label), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 8,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "small",
        onClick: () => component.openEditCompanyActivityModal({
          id: currentCompanyActivity._id
        }),
        className: "u-margin-left-5 u-margin-right-5"
      }, /*#__PURE__*/_react.default.createElement(_Create.default, null)), /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "secondary",
        variant: "contained",
        size: "small",
        onClick: () => component.openDeleteCompanyActivityModal({
          id: currentCompanyActivity._id
        }),
        className: "u-margin-left-5 u-margin-right-5"
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))));
    });
    let createCompanyActivity = /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "u-margin-bottom-30 u-margin-left-15 u-margin-right-15 u-padding-top-5 u-padding-bottom-20 u-padding-left-15 u-padding-right-15",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Ajouter une activit\xE9"), /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/company-activity/create"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company_activity[label]'],
      name: "company_activity[label]",
      type: "text",
      label: "Nom de l'activit\xE9",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 8,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "button",
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, "Valider", loader))), status));
    let output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, createCompanyActivity, /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "u-margin-bottom-30 u-margin-left-15 u-margin-right-15 u-padding-top-20 u-padding-bottom-20 u-padding-left-15 u-padding-right-15",
      elevation: 2
    }, listCompanyActivity), /*#__PURE__*/_react.default.createElement(_EditCompanyActivityModal.default, {
      id: state.editedCompanyActivityId,
      open: state.editCompanyActivityModalOpen,
      onClose: component.closeEditCompanyActivityModal
    }), /*#__PURE__*/_react.default.createElement(_DeleteCompanyActivityModal.default, {
      id: state.deletingCompanyActivityId,
      open: state.deleteCompanyActivityModalOpen,
      onClose: component.closeDeleteCompanyActivityModal
    }));
    return output;
  }
}
exports.default = CompanyActivityForm;
